module.exports = __webpack_public_path__ + "img/gta5.e3255950.png";